<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="address" slot-scope="prop">
        <ChooseAddressMap
          v-model="prop.form.address"
          :disabled="prop.item.disabled"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
  getFileUrl,
} from 'api';
import {
  servicerSelectList,
} from 'api/service';
import ChooseAddressMap from 'components/chooseAddressMap/chooseAddressMap';
export default {
  components: {
    ChooseAddressMap,
  },
  data () {
    return {
      baseForm: {
        oilCardTypeOptions: [], // 油站类型
        locationTypeOptions: [], // 所属位置
        form: [
          {
            label: '产品名称',
            value: 'productName',
            type: 'input',
            disabled: false,
          },
          {
            label: '服务地址',
            value: 'address',
            default: {},
            slot: true,
            disabled: false,
          },
          {
            label: '服务电话',
            value: 'serviceCall',
            type: 'input',
            disabled: false,
          },
          {
            label: '产品状态',
            value: 'state',
            type: 'select',
            options: [
              {
                label: '有效',
                value: 1,
              },
              {
                label: '无效',
                value: 0,
              },
            ],
          },
          {
            label: '油站类型',
            value: 'oilCardType',
            type: 'select',
            disabled: false,
            hide: true,
          },
          {
            label: '所属位置',
            value: 'locationType',
            type: 'select',
            disabled: false,
          },
          {
            label: '站点图片',
            value: 'productPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
            disabled: false,
          },
          {
            label: '产品简介',
            value: 'introduce',
            type: 'input',
            attr: {
              type: 'textarea',
            },
            disabled: false,
          },
        ],
        rules: {
          productName: [ // 产品名称
            { required: true, message: '请输入产品名称', trigger: 'blur' },
          ],
          address: [ // 服务地址
            { required: true, message: '请选择服务地址', trigger: 'blur' },
          ],
          serviceCall: [ // 服务电话
            { required: true, message: '请输入服务电话', trigger: 'blur' },
          ],
          state: [ // 产品状态
            { required: true, message: '请选择产品状态', trigger: 'blur' },
          ],
          oilCardType: [ // 油站类型
            { required: true, message: '请选择油站类型', trigger: 'blur' },
          ],
          locationType: [ // 所属位置
            { required: true, message: '请选择所属位置', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    receiveData (tar, val) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: val.serviceType !== 1,
        names: ['oilCardType'],
      });
    },
    async getList () {
      this.baseForm.serviceUserIdOptions = await servicerSelectList();
      const enumsList = await getEnumList({
        codeType: 'PRODUCT_CARD_TYPE,LOCATION_TYPE',
      });
      this.baseForm.oilCardTypeOptions = enumsList[0];
      this.baseForm.locationTypeOptions = enumsList[1];
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.productPic && formData.productPic[0]) { // 油站图片
          formData.productPicId = formData.productPic[0].id;
          formData.productPicUrl = formData.productPic[0].url;
        }
        delete formData.productPic;
        formData.provinceId = formData.address.provinceId; // 省
        formData.cityId = formData.address.cityId; // 市
        formData.countryId = formData.address.countryId; // 县区
        formData.nand = formData.address.lat; // 纬度
        formData.eand = formData.address.lng; // 经度
        formData.address = formData.address.address;
      }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      data.address = {
        provinceId: data.provinceId, // 省
        cityId: data.cityId, // 市
        countryId: data.countryId, // 县区
        lat: data.nand, // 纬度
        lng: data.eand, // 经度
        address: data.address,
      };
      if (data.productPicId && !data.productPicUrl) {
        const imgRes = await getFileUrl({
          flowIds: data.productPicId,
        });
        data.productPic = [{
          id: data.productPicId,
          url: imgRes.items[0].fullPath,
        }];
      } else if (data.productPicId) {
        data.productPic = [{
          id: data.productPicId,
          url: data.productPicUrl,
        }];
      } else {
        data.productPic = [];
      }
      // 油站类型
      if (data.oilCardType) {
        data.oilCardType = String(data.oilCardType);
      }
      // 所属位置
      if (data.locationType) {
        data.locationType = String(data.locationType);
      }
      this.$refs.baseForm.setVal('form', data);
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
        names: [
          'productName', 'address', 'serviceCall',
          'oilCardType', 'locationType', 'productPic',
          'introduce',
        ],
      });

      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !(Number(this.$route.query.serviceType) === 1),
        names: ['oilCardType'],
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
